import { render, staticRenderFns } from "./Irregularly.vue?vue&type=template&id=01f630c4&scoped=true&"
import script from "./Irregularly.vue?vue&type=script&lang=js&"
export * from "./Irregularly.vue?vue&type=script&lang=js&"
import style0 from "./Irregularly.vue?vue&type=style&index=0&id=01f630c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f630c4",
  null
  
)

export default component.exports